import List from "joynt/participants/ParticipantList";
import {ProfileInfoPopover} from "./ProfileInfo";
import popoverHook from "./hooks/useProfilePopover";

export const ParticipantList = List;
export const ProfilePopover = ProfileInfoPopover;
export const useProfilePopover = popoverHook;